export const SELF_HANDLED_SCROLLING_APPS = ['mf-productlist'];